import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect } from "react";
import { useAtom } from "jotai";
import { popupAtom } from "./popupAtom";
import { PopupProps } from "./Popup.d";
export const usePopup = () => {
  const $ = _c(13);
  const [queue, setQueue] = useAtom(popupAtom);
  let t0;
  if ($[0] !== setQueue) {
    t0 = () => setQueue(_temp);
    $[0] = setQueue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClose = t0;
  let t1;
  if ($[2] !== handleClose || $[3] !== queue) {
    t1 = () => {
      if (queue.length > 0) {
        const [t2] = queue;
        const {
          timeout: t3
        } = t2 === undefined ? {
          timeout: 5000
        } : t2;
        const timeout = t3 === undefined ? 5000 : t3;
        setTimeout(handleClose, timeout);
      }
    };
    $[2] = handleClose;
    $[3] = queue;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== handleClose || $[6] !== queue || $[7] !== setQueue) {
    t2 = [handleClose, queue, setQueue];
    $[5] = handleClose;
    $[6] = queue;
    $[7] = setQueue;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  const t3 = queue.length > 0;
  const t4 = queue[0] as PopupProps;
  let t5;
  if ($[9] !== handleClose || $[10] !== t3 || $[11] !== t4) {
    t5 = {
      isOpen: t3,
      props: t4,
      onClose: handleClose
    };
    $[9] = handleClose;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
function _temp(q) {
  return q.length === 1 ? [] : q.slice(1);
}